<template>
  <div class="ui segment">

    Akcijas preces ...

  </div>
</template>

<script>

export default {

  data () {
    return {
      msg: 'Welcome to Your Vue.js App 2'
    }
  }
}
</script>



// WEBPACK FOOTER //
// DiscountedGoodsPage.vue?ae7e0112